"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALWAYS_ENABLED_APPS = exports.SUPPORTED_APPS = exports.FEED_WIDGET_SECRET_SLUG = exports.SECRET_SLUG = void 0;
const types_1 = require("@wix/ambassador-social-groups-v1-group-app/types");
exports.SECRET_SLUG = 'secret-group-slug-used-for-editor';
exports.FEED_WIDGET_SECRET_SLUG = 'secret-publicgroup-slug-used-for-editor';
exports.SUPPORTED_APPS = [
    types_1.GroupAppKey.MEMBERS_APP,
    types_1.GroupAppKey.FEED_APP,
    types_1.GroupAppKey.ABOUT_APP,
    types_1.GroupAppKey.GALLERY_APP,
    types_1.GroupAppKey.FILES_APP,
    types_1.GroupAppKey.EVENTS_APP,
    types_1.GroupAppKey.CUSTOM_APP,
    types_1.GroupAppKey.CUSTOM_APP_2,
    types_1.GroupAppKey.CUSTOM_APP_3,
];
exports.ALWAYS_ENABLED_APPS = [
    types_1.GroupAppKey.FEED_APP,
    types_1.GroupAppKey.ABOUT_APP,
];
//# sourceMappingURL=constants.js.map